import React from "react";
import { LegacyCard, InlineGrid, TextField, Select } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import { NameLabelColor, } from "../CoatData";
import { useLibrary } from "../LibraryContext";

const MenBomberForm = ({
  form,
  setForm,
  errors,
  baseUrl,
  setApploader,
  conditionalFieldsMap,
  viewOrder
}) => {
  const { fabrics: Fabrics, linings: LiningNumbers } = useLibrary();
  const handleChange =
    (section, key = null, checkArray = true) =>
    (values) => {
      const trimmedKey = key?.trim();
      let value;
      if (Array.isArray(values)) {
        if (checkArray) {
          value = values[0];
        } else {
          value = values;
        }
      } else {
        value = values;
      }

      const sectionMap = conditionalFieldsMap[section];
      const fieldRule = sectionMap?.[trimmedKey];

      if (fieldRule) {
        const { conditionValue, dependentKey } = fieldRule;
        if (value === conditionValue) {
          // Add the dependent field
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
              [dependentKey]: "",
            },
          }));
        } else {
          // Remove the dependent field
          const updatedSection = { ...form[section] };
          delete updatedSection[dependentKey];
          updatedSection[trimmedKey] = value;

          setForm((prev) => ({
            ...prev,
            [section]: updatedSection,
          }));
        }

        return;
      }
      // Default update
      if (trimmedKey) {
        setForm((prev) => ({
          ...prev,
          [section]: {
            ...prev[section],
            [trimmedKey]: value,
          },
        }));
      } else {
        setForm((prev) => ({
          ...prev,
          [section]: value,
        }));
      }
    };

  const MenBomberFields = [
    {
      label: "Collar Fabric",
      key: "collarFabric",
      type: "select",
      options: ["Black- QLWB005", "QLWB045", "QLWB003", "QLWB039", "QLWB036", "QLWB034", "QLWB033", "QLWB032", "QLWB031", "QLWB030", "QLWB028", "QLWB027", "QLWB025", "QLWB024", "QLWB023", "QLWB022", "QLWB021", "QLWB010", "QLWB002", "QLWB019", "QLWB018", "QLWB017", "QLWB016", "QLWB013", "QLWB006", "Match Fabric"],
    },
    {
      label: "Bottom Fabric",
      key: "bottomFabric",
      type: "select",
      options: ["Black- QLWB005", "QLWB045", "QLWB003", "QLWB039", "QLWB036", "QLWB034", "QLWB033", "QLWB032", "QLWB031", "QLWB030", "QLWB028", "QLWB027", "QLWB025", "QLWB024", "QLWB023", "QLWB022", "QLWB021", "QLWB010", "QLWB002", "QLWB019", "QLWB018", "QLWB017", "QLWB016", "QLWB013", "QLWB006"],
    },
    {
      label: "Cuff Fabric",
      key: "cuffFabric",
      type: "select",
      options: ["Black- QLWB005", "QLWB045", "QLWB003", "QLWB039", "QLWB036", "QLWB034", "QLWB033", "QLWB032", "QLWB031", "QLWB030", "QLWB028", "QLWB027", "QLWB025", "QLWB024", "QLWB023", "QLWB022", "QLWB021", "QLWB010", "QLWB002", "QLWB019", "QLWB018", "QLWB017", "QLWB016", "QLWB013", "QLWB006"],
    },
    {
      label: "Zipper",
      key: "zipper",
      type: "select",
      options: ["Silver", "Gold"],
    },
    {
      label: "Custom Lining",
      key: "customLining",
      type: "select",
      options: ["No", "Yes"],
    },
    {
      label: "Lining Number",
      key: "liningNumber",
      type: "select",
      options: LiningNumbers,
    },
    {
      label: "Name Label Font",
      key: "nameLabelFont",
      type: "select",
      options: ["Caligraphy", "Times Roman", "Block", "Script", "Bradley", "Old English", "Custom Upload"],
    },
    {
      label: "Name Label Color",
      key: "nameLabelColor",
      type: "select",
      options: NameLabelColor,
    },
    { label: "Name Label Text", key: "nameLabelText" },
  ];

  const handleFileUpload = async (section, key, file) => {
    const formData = new FormData();
    formData.append("image", file);
    setApploader(true);
    try {
      const res = await fetch(`${baseUrl}/api/files/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        const uploadedFilename = data.files;
        handleChange(section, key)(uploadedFilename);
        setApploader(false);
      } else {
        alert("File upload failed");
      }
    } catch (error) {}
  };

  const multipleFileUpload = async (section, key, files) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("images", files[i]);
    }
    setApploader(true);
    try {
      const res = await fetch(`${baseUrl}/api/files/upload-multiple`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        const uploadedFilename = data.files;
        handleChange(section, key, false)(uploadedFilename);
        setApploader(false);
      } else {
        alert("File upload failed");
      }
    } catch (error) {}
  };

  const handleDownload = async (url) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = url.split("/").pop() || "download.png";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
    }

  };

  const renderSection = (title, fields, sectionKey) => (
    <LegacyCard title={title} sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        {fields.map(({ label, key, type = "text", options = [] }) => {
          if (type === "select") {
            return (
                <React.Fragment key={key}>
                {key !== "liningNumber" && (
                  <div className="two_culumn">
                    <Select
                      label={label}
                      options={options}
                      value={form[sectionKey]?.[key] || ""}
                      onChange={handleChange(sectionKey, key)}
                      error={errors[sectionKey]?.[key]}
                    />
                    {key === "nameLabelFont" &&
                        form[sectionKey]?.[key] === "Custom Upload" && (
                          <input
                            type="file"
                            className="imgUpload"
                            key="nameLabelFontFile"
                            accept=".jpg, .jpeg, .png"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (!file) return;
                              handleFileUpload(
                                sectionKey,
                                "nameLabelFontFile",
                                file
                              );
                            }}
                            error={errors[sectionKey]?.["nameLabelFontFile"]}
                          />
                        )}
                        {viewOrder === 'yes' &&
                        form[sectionKey]?.[key] === "Custom Upload" && (
                        form.menBomber.nameLabelFontFile ? (
                            <img
                            className="image_server"
                            onClick={() => handleDownload(form.menBomber.nameLabelFontFile)}
                            src={form.menBomber.nameLabelFontFile}
                            alt="Mark Russell"
                            />
                        ) : null
                        )}
                    {key === "customLining" &&
                      form[sectionKey]?.[key] === "Yes" && (
                        <>
                          <Select
                            label="Template"
                            options={[
                              { label: "Select template", value: "" },
                              { label: "Repeat", value: "Repeat" },
                              { label: "Photos Straight", value: "Photos Straight" },
                              { label: "Photos Scattered", value: "Photos Scattered" },
                              { label: "1 Large", value: "1 Large" },
                              { label: "1 Large + Side Photos", value: "1 Large + Side Photos" },
                            ]}
                            value={form[sectionKey]?.customLiningTemplate || ""}
                            onChange={handleChange(sectionKey, "customLiningTemplate")}
                            error={errors[sectionKey]?.["customLiningTemplate"]}
                          />
                          <input
                            type="file"
                            className="imgUpload"
                            accept=".jpg, .jpeg, .png"
                            key="customLiningFile"
                            multiple
                            onChange={(e) => {
                              const files = e.target.files;
                              if (!files.length) return;
                              if (files.length > 7) {
                                alert("You can only upload a maximum of 7 files.");
                                e.target.value = "";
                                return;
                              }
                              multipleFileUpload(
                                sectionKey,
                                "customLiningFile",
                                files
                              );
                            }}
                            error={errors[sectionKey]?.["customLiningFile"]}
                          />
                        </>
                      )}
                    {viewOrder === 'yes' &&
                      label === "Custom Lining" &&
                      form[sectionKey]?.[key] === "Yes" && (
                        <div className="image_server_main">
                          {(Array.isArray(form.menBomber?.customLiningFile)
                            ? form.menBomber.customLiningFile
                            : form.menBomber?.customLiningFile
                              ? [form.menBomber.customLiningFile]
                              : []
                          ).map((file, index) => (
                            <img
                              key={index}
                              className="image_server"
                              onClick={() => handleDownload(file)}
                              src={file}
                              alt="Mark Russell"
                            />
                          ))}
                        </div>
                      )}
                  </div>
                )}
                {key === "liningNumber" &&
                  !(form[sectionKey]?.customLining === "Yes") && (
                  <CustomAutocomplete
                    label={label}
                    optionsList={options}
                    onChange={handleChange(sectionKey, key)}
                    defaultValue={form[sectionKey]?.[key] || ""}
                  />
                )}
             </React.Fragment>
            );
          }
          return (
            <TextField
              key={key}
              label={label}
              value={form[sectionKey]?.[key] || ""}
              onChange={handleChange(sectionKey, key)}
              error={errors[sectionKey]?.[key]}
            />
          );
        })}
      </InlineGrid>
    </LegacyCard>
  );

  return renderSection("Men Bomber", MenBomberFields, "menBomber");
};

export default MenBomberForm;
